import { MasterOption } from './masterData';

// 性別オプション
export const genderOptions: MasterOption[] = [
  { value: 'male', label: '男性' },
  { value: 'female', label: '女性' },
  { value: 'other', label: 'その他' },
];

// 年齢範囲オプション
export const ageRangeOptions: MasterOption[] = [
  { value: '1', label: '18-25歳' },
  { value: '2', label: '26-35歳' },
  { value: '3', label: '36-45歳' },
  { value: '4', label: '46-55歳' },
  { value: '5', label: '56-65歳' },
  { value: '6', label: '66歳以上' },
];

// 滞在期間オプション
export const stayDurationOptions: MasterOption[] = [
  { value: '1', label: '1週間未満' },
  { value: '2', label: '1週間-1ヶ月' },
  { value: '3', label: '1ヶ月-3ヶ月' },
  { value: '4', label: '3ヶ月-6ヶ月' },
  { value: '5', label: '6ヶ月-1年' },
  { value: '6', label: '1年以上' },
];

// 予算範囲オプション
export const budgetOptions: MasterOption[] = [
  { value: '1', label: '10万円未満' },
  { value: '2', label: '10-30万円' },
  { value: '3', label: '30-50万円' },
  { value: '4', label: '50-100万円' },
  { value: '5', label: '100万円以上' },
];

export const terms: string =
`二地域居住ポータルサイト利用規約

本規約は、ANAの二地域居住 BLUE SKY LIFE（以下「本サイト」といいます）の利用に関する条件を定めるものです。本サイトをご利用になる前に、下記のご利用条件をよくお読みいただき、ご同意の上ご利用いただくようお願い申し上げます。万一ご同意いただけない場合には、大変申し訳ございませんがご利用をお控えください。ご利用いただいた場合、利用者は、下記の条件すべてにご同意いただいたものとして取り扱わせていただきます。

第1条（定義）
  ●	「利用者」：本サイトを利用するすべての利用者。
  ●	「運営者」：本サイトの運営者（ANAあきんど株式会社）。
  ●	「ユーザー」：本サイトに利用登録をし、運営者による登録承認通知を受け取った利用者の総称。
  ●	「本サービス」：本サイトで提供するサービスの総称。
  ●	「提携事業者」：当社と提携し、特定のプランにおいて自社のポイントサービス等を提供する事業者（交通事業者、地域事業者等を含みます）。
  ●	「提携ポイント」：提携事業者が発行・運営するポイント。
  ●	「個別規約」：提携事業者の特定のプラン等に適用される、本規約以外の個別の規約の総称。

第2条（本規約の適用）
  1.	本規約は、本サイトの利用者（以下「利用者」といいます）と、本サイトの運営者（以下「運営者」といいます）との間の、本サイトの利用に関する一切の関係に適用されるものとします。
  2.	運営者は、以下のいずれかの場合には利用者の承諾を得ることなく、本サイトへの掲示、その他の適宜の方法により、本規約を変更する旨およびその内容、効力発生時期を周知することによって本規約を変更できるものとします。変更後の本規約は、運営者が別途定める場合を除き、本サイト上に表示した時点より、効力を生じるものとします。本規約の変更後、利用者が本サイトの利用を開始した場合は、変更後の規約に同意したものとみなします。
  ○	本規約の変更が利用者の一般の利益に適合するとき。
  ○	本規約の変更が本サービスの利用目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき。
  3.	運営者が、本サービスの特定のプランや機能に関して別途、「個別規約」を定めた場合、利用者は本規約に加えて当該個別規約にも従うものとします。本規約と個別規約の内容が矛盾抵触する場合は、個別規約が優先して適用されるものとします。

第3条（本サイトの目的）
  1.	本サイトは、二地域居住に関心を持つ方々に対して、二地域居住に関するサービス（以下、「本サービス」といいます）の提供、二地域居住に関する情報の提供、関連サービスの紹介をすること等を目的としています。

第4条（利用登録）
  1.	本サイトの一部の機能（本サービスへの申込み等）を利用するためには、利用登録が必要です。
  2.	利用登録を希望する者（以下「登録希望者」といいます）は、本規約に同意の上、運営者が定める方法により登録の申込みを行い、運営者がこれを承認することによって利用登録が完了するものとします。
  3.	運営者は、登録希望者が以下のいずれかの事由に該当すると判断した場合、登録を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
  ○	登録申込み内容に虚偽、誤記または記載漏れがあった場合
  ○	本規約に違反するおそれがあると運営者が判断した場合
  ○	過去に本サイトの利用規約に違反したことがある場合
  ○	未成年者、成年被後見人、被保佐人または被補助人のいずれかに該当し、法定代理人、後見人、保佐人または補助人の同意等を得ていない場合
  ○	本規約第19条に定める反社会的勢力またはその構成員や関係者である者、もしくはそのおそれがあると運営者が判断した者である場合
  ○	その他、運営者が登録を不適当と判断した場合
  4.	運営者は、登録を承認した場合、登録希望者に対し、登録完了の通知を行うものとします。これにより、登録希望者は本サイトのユーザーとなり、本規約に従って本サイトを利用できるようになります。

第5条（お試し二地域プランへの参加申込み）
  1.	お試し二地域プラン（以下「本プラン」）の参加者は、本規約に同意して申込みを行うものとし、申込みと同時に以下に同意したものとします。
  ○	滞在希望地域（以下、滞在先地域）の地域活性化に貢献すること
  ○	本プランの利用実績について運営者が確認すること
  2.	参加確定後、利用者は所定のフォームよりクレジットカード番号の登録を行うものとします。登録されたクレジットカードは、プランのキャンセル料（ANA SKY コインまたは提携ポイント付与相当額）や、不正利用（目的外利用）された場合の精算のために利用されます。

第6条（参加条件）
  1.	本プランの参加にあたっては以下の条件を満たす必要があります。
  ○	滞在先地域が設定する地域体験メニューに参加すること。
  ○	二地域居住の課題解決に向けたアンケートへの回答をすること。

第7条（お試し二地域プランの内容および制限）
  1.	本プランは、地域体験メニューと航空移動における負担軽減サポート（ANA SKY コインまたは提携ポイントの付与）から構成されています。なお、航空移動における負担軽減サポートの利用には、参加条件として定める地域体験メニューへの参加が必須となります。
  2.	地域体験メニューとは、各自治体が本プランへの参加条件として設定するメニューです。本サイトの運営者はその内容、質、安全性、料金の支払い、債務、実施等に関する一切の責任を負いません。利用者が地域体験メニューの利用により損害を被った場合、または第三者に損害を与えた場合であっても、本サイトおよび運営者は、その損害について一切の責任を負わないものとします。利用者は、自己の責任と費用において、地域体験メニュー提供事業者または第三者との間でこれを解決するものとします。
  3.	移動における負担軽減サポートは、対象路線・期間において、ANAウェブサイトでの航空券購入に利用できるANA SKY コイン（「選べるe-GIFT」を通じて付与）、または提携事業者が提携発行する提携ポイント等を提供するものです。

第8条（ANA SKY コインによるサポート利用の注意事項）

  1. ANA SKY コインの概要と提供
  ○	ANA SKY コインとは：ANAウェブサイトでの航空券等の支払いに利用できる電子クーポンです。本プランの対象は、各訪問先地域ごとに指定する路線・期間のご利用に限ります。その他、ANA SKY コインについての詳細はこちらをご確認ください。 [ANA SKY コインについて](https://www.ana.co.jp/ja/jp/amc/skycoin/)
  本プランにてANA SKYコインを活用してお取りいただける運賃は、エコノミークラスのシンプル、スタンダードのみが対象となります。（ファーストクラス、セール運賃、フレックス運賃、株主優待割引、株主向けシンプル運賃割引等については対象外となりますのでご注意ください。）
  ○	提供方法：本プランでは、ANA SKY コインに交換可能な「選べるe-GIFT」の専用URLを送付することで付与を行います。なお、本プランでお渡しする選べるe-GIFTは、ANA SKY コインにのみ交換可能です。
  付与するANA SKY コインの対象路線、付与数、期間等については、[一覧リスト](https://www.ana-akindo.co.jp/activities/2chiiki/anaskycoin/)をご確認ください。（付与するANA SKY コイン数（往復）については、最低運賃の変動に伴い、期間中に変更となる可能性がございます。最新情報は[一覧リスト](https://www.ana-akindo.co.jp/activities/2chiiki/anaskycoin/)をご確認ください。）
  小児、障がい者割引をご利用の際は、お申込みフォームよりその旨ご申告ください。
  訪問地域までANA便を乗り継いでいらっしゃる場合には、ご利用の路線に合わせて付与数を決定いたします。お申込みの際にご利用路線をご申請ください。
  その他、選べるe-GIFTについての詳細はこちらをご確認ください。 [選べるe-GIFTについて](https://www.anatc-gift.com/use/)
  ○	交換と期限：事務局より送付されたURLにてANA SKY コインを選択することで即時に交換可能です。選べるe-GIFTの交換期限はURL発行から6か月、交換後のANA SKY コインの有効期限は12ヶ月です。

  2. 参加方法（ステップ）
  本プランへの参加と航空サポートの受領は、以下の7つのステップで行います。
  1.	利用登録：まずはポータルサイト「ANAの二地域居住　BLUE SKY LIFE」にご利用登録ください。
  2.	お試し二地域プランへの申込み：各種規約・注意事項をご確認のうえ、ご希望の地域のプラン内容を確認し、申込みフォームよりお申込みください。※自治体にて申込み日程、申込者情報の確認（参加可否の審査）が行われます。
  3.	プラン参加確定のご連絡：参加が確定となりましたら、事務局よりその旨ご連絡しますので、所定のフォームよりクレジットカード番号のご登録をお願いいたします。クレジットカードは、参加確定後プラン参加をキャンセルされる場合または不正利用された場合において、所定の精算のために利用いたします。詳しくは、注意事項をご確認ください。
  4.	ANA SKY コインの受領：事務局よりANA SKY コインに交換可能な選べるe-GIFTをお送りいたします。お客様にて、選べるe-GIFTをANA SKY コインに交換していただきます。
  5.	航空券の予約・購入：交換したANA SKY コインを活用してANAウェブサイトから航空券をご予約、ご購入いただきます。ANAウェブサイトにて、ご参加の日程のご希望の便・運賃を選択いただき、搭乗者情報をご入力ください。支払い画面にて、ANA SKY コインを支払方法として選択いただき、「ANA SKY コインを利用」の欄において、交換したANA SKY コインのコイン数をご入力ください。残額についてはご希望の支払方法にてご対応いただき、航空券の購入が完了いたします。※ただし、訪問先地域ごとに指定する路線・期間のご利用に限ります。※対象はエコノミークラスのシンプル、スタンダードとなります（ファーストクラス、セール運賃、フレックス運賃、株主優待割引、株主向けシンプル運賃割引等については対象外となりますのでご注意ください。）。シンプル往復運賃でのご予約の場合、片道のみのキャンセルはできません。詳細は[こちら](https://www.ana.co.jp/ja/jp/guide/plan/fare/domestic/charge-list/#anchor002)をご確認ください。また、ご購入にあたり、下段の注意事項をご確認ください。
  6.	航空券ご購入後、事務局へ便名・確認番号をご連絡ください。事務局にて、お客様のご予約状況を確認させていただきます。
  7.	プラン参加：予約した航空便で対象地域を訪問し、お申込みいただいたお試し二地域プランにご参加ください。
  8.	アンケート回答：プラン参加終了後、事務局より事後アンケートを送付させていただきますので、回答にご協力をお願いいたします。また、事務局にてお客様のご搭乗実績を確認させていただきます。

  3. 予約・購入および運賃の制限
  ○	対象運賃：エコノミークラスのシンプル、スタンダードのみが対象です。ファーストクラス、エコノミークラスのセール運賃、フレックス、株主優待割引、株主向けシンプル運賃割引等については対象外となります。
  ○	自己手配：航空券は利用者がANAウェブサイトにて直接予約・購入するものとします。不足分は利用者のクレジットカード等で決済してください。

  4. キャンセルポリシーと精算
  ○	航空券購入前のキャンセル：事務局からの本プラン参加確定のご連絡後、航空券のご購入前に本プラン参加のキャンセルをご希望の場合、事務局へメールにてご連絡ください。利用者は、理由を問わず、発行済み選べるe-GIFT相当額を負担するものとし、事務局において登録済みクレジットカードより当該相当額を引き落とします。なお、ANA SKY コインへ交換可能な選べるe-GIFTは、本プラン参加確定時点で発行手続きを行います。キャンセル時点で選べるe-GIFTの送付が完了していない場合にも、後日お送りすることとなりますので予めご了承ください。精算後、付与されたANA SKY コインは本プラン以外の目的で利用可能です。
  ○	航空券購入後のキャンセル：お客様にて航空券ご購入後に本プラン参加のキャンセルをご希望の場合、キャンセル希望の旨をメールにて事務局までご連絡ください。
  予約の取り消し・航空券の払い戻しにつきましては、お客様ご自身でANAウェブサイトよりお手続きください。なお、各種手数料については、以下のリンクよりご確認ください。[航空券の各種手数料について（国内線）](https://www.ana.co.jp/ja/jp/guide/plan/fare/domestic/charge/)
  選べるe-GIFT（ANA SKY コイン）相当額のキャンセル料を事前にご登録いただいたクレジットカードから引き落とさせていただきます。なお、キャンセル後は、プラン対象路線・期間に限定されることなくANA SKY コインをご利用いただけます。
  ※航空券の払い戻しをご希望される場合は本プランのキャンセルとなります。
  ○	不正利用（目的外利用）の禁止：本プラン参加確定後に送付した選べるe-GIFTから交換されたANA SKY コインを、本プランの対象路線、対象期間、対象地域への訪問以外（例：別の旅行等）に使用したことが判明した場合は、付与相当額（例：5,000ANA SKY コインに交換可能な選べるe-GIFTを付与した場合には、5,000円）を返還いただきます（事前にご登録いただいたクレジットカードにご請求いたします）。
  ※本プランキャンセル時にキャンセル料をお支払いいただいた場合を除きます。

  5. 日程変更
  航空券の手配完了後、ご利用便の日程変更を希望される場合は、事務局へ変更希望日と便名をご連絡ください。事務局にて、ご希望の日程でプランの受け入れが可能か各自治体へ確認いたします。
  自治体の受け入れ承諾が得られましたらその旨をご連絡いたしますので、その後、お客様ご自身にてANAウェブサイトより変更のお手続きをお願いいたします。
  なお、変更に伴う各種手数料については、以下のリンクよりご確認ください。[航空券の各種手数料について（国内線）](https://www.ana.co.jp/ja/jp/guide/plan/fare/domestic/charge/)
  ※取消手数料は航空券購入時に使用したANA SKY コインから優先的に充当されます。変更後の航空券をご購入される際には、取消手数料が差し引かれた後の残りのスカイコインを活用し、ご購入ください。
  ※日程の変更については、本プラン参加可能期間（2026年7月15日〜2027年2月28日）のみ承ります。期間外の変更をご希望される場合は本プランのキャンセルとなります。
  ※訪問当日の欠航・遅延などが発生した場合には、ご訪問予定の自治体へのご連絡をさせていただきますので、株式会社スカイツアーズ（050-1753-8400）へご連絡ください。なお、その他航空券に関するお手続きはお客様ご自身でご対応いただいております。

  6. その他の条件
  ○	利用登録時および申込み時に提示される利用規約を必ず確認し、同意の上でお手続きください。
  ○	利用人数が上限に達し次第、終了となります（上限人数については、各自治体ページをご確認ください。）。
  ○	販売座席数には限りがあり、路線・便によってはご利用いただけない場合がございます。
  ○	予約・購入期間、払い戻し、変更、マイル積算等の規定はすべて各種運賃の規定に準じます。詳細はこちらをご確認ください。 [運賃一覧](https://www.ana.co.jp/ja/jp/guide/plan/fare/domestic/rules-list/)

第9条（提携ポイント等を利用するプランの特則）
  1.	運営者が指定する特定のプランにおいては、前条のANA SKY コインに代わり、またはこれに加えて、提携事業者が発行する提携ポイントが付与および利用される場合があります。
  2.	提携ポイントの利用には、対象となる提携事業者が定める有効なアカウント（ID）との連携等の手続きが必要となる場合があります。
  3.	提携ポイントを利用するプランにおけるポイントの利用条件、充当条件ルール、他の決済手段との併用、キャンセル時のポイント返還の取り扱いその他の詳細については、当該プラン申込時に提示される個別規約、および当該提携事業者が定める利用規約等に従うものとします。

第10条（本サイトの変更、中断、終了）
  1.	運営者は、事前に利用者に通知することなく、本サイトの内容を変更、追加、または廃止することができるものとします。
  2.	運営者は、以下のいずれかの事由に該当する場合、事前に利用者に通知することなく、本サイトの全部または一部の提供を一時的に中断または終了することができるものとします。
  ○	本サイトのシステムメンテナンスを行う場合
  ○	コンピューター、通信回線等が障害、誤操作、過度なアクセスの集中、不正アクセス、ハッキング等の事故により停止した場合
  ○	火災、停電、地震、洪水等の自然災害、その他の不可抗力事由により本サイトの提供が困難となった場合
  ○	その他、運営者が本サイトの提供を一時的に中断または終了することが必要と合理的に判断した場合
  3.	運営者は、本条に基づき本サイトの変更、中断、終了を行った場合でも、利用者に対して何らの責任を負わないものとします。

第11条（アカウント情報の管理）
  1.	ユーザーは、自己の責任において、本サイトの利用登録時に設定したアカウント情報（以下「アカウント情報」といいます）を厳重に管理するものとします。
  2.	ユーザーは、アカウント情報を第三者に利用させ、または譲渡、貸与、名義変更、売買等をしてはならないものとします。ユーザー情報を利用して行われた本サービス上の一切の行為は、ユーザーの行為とみなします。
  3.	アカウント情報の管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任は、運営者の責めに帰すべき事由があるときを除き、ユーザーが負うものとします。
  4.	ユーザーは、アカウント情報が第三者に漏洩し、または不正に利用された可能性がある場合、直ちに運営者に連絡するものとします。

第12条（利用者の責任）
  1.	利用者は、自己の責任において本サイトを利用するものとします。
  2.	利用者は、本サイトを通じて得た情報について、その正確性、完全性、有用性等について、自己の責任において判断し、利用するものとします。
  3.	利用者は、本サイトの利用に関連して、第三者との間で紛争が生じた場合、自己の責任と費用においてこれを解決するものとします。

第13条（禁止事項）
  1.	利用者は、本サイトの利用にあたり、以下の行為を行ってはならないものとします。
  ○	法令または公序良俗に違反する行為
  ○	犯罪行為に関連する行為
  ○	運営者、他の利用者または第三者の著作権、商標権、プライバシー権、その他の権利を侵害する行為、または侵害するおそれのある行為
  ○	運営者、他の利用者または第三者に不利益または損害を与える行為、または損害を与えるおそれのある行為
  ○	運営者、他の利用者または第三者を誹謗中傷し、または名誉もしくは信用を傷つける行為、またはそのおそれのある行為
  ○	本サイトの運営を妨害するおそれのある行為
  ○	虚偽の情報を登録または投稿する行為
  ○	コンピュータウイルスその他の有害なプログラムを送信または書き込む行為
  ○	本規約、本サービスに関連するその他の規約、ルールおよびガイドライン等に違反する行為、または本サイトの趣旨に反する行為
  ○	その他、運営者が不適切と合理的に判断する行為
  2.	利用者の本規約に反した行為または不正もしくは違法な行為により運営者、他の利用者、または第三者が損害を受けた場合には、当該利用者に対して損害（特別損害、逸失利益および弁護士費用を含みます。）賠償の請求をする場合があります。

第14条（著作権等）
  1.	本サイトに掲載されている全てのコンテンツ（文章、画像、動画、プログラム等）に関する著作権その他一切の権利は、運営者または正当な権利を有する第三者に帰属します。利用者は、これらのコンテンツを私的利用の範囲を超えて利用することはできません。

第15条（利用登録の解除）
  1.	ユーザーは、運営者に届出を行うことで利用登録を解除することができます。

第16条（情報の削除、利用停止等）
  1.	運営者は、利用者が本規約に違反した場合、登録事項に虚偽の事実があることが判明した場合またはその他の理由により本サイトの運営上不適切と合理的に判断した場合、事前に通知することなく、当該利用者による本サイトの利用を停止し、ユーザー登録を抹消し、または登録情報および投稿情報を削除することができるものとします。

第17条（免責事項）
  1.	運営者は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティ等に関する欠陥、エラーやバグ、権利侵害等を含みます。）がないことを明示的にも黙示的にも保証しておりません。
  2.	運営者は、本サイトの利用により利用者に生じた損害について、一切の責任を負わないものとします。ただし、運営者の故意または重過失による場合はこの限りではありません。また、運営者の重大な過失を除く過失（軽過失）による場合には、利用者に生じた通常かつ直接の損害に限り賠償し（逸失利益、間接損害、特別損害を除きます）、賠償額の上限は、利用者が運営者に支払った対価相当額、または無償サービスにおいては25,000円とします。
  3.	運営者は、本サイトの停止、中断、変更、終了等により利用者に生じた損害について、一切の責任を負わないものとします。
  4.	運営者は、本サイトに関して、利用者とほかの利用者または第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。
  5.	本サイトから他のウェブサイトへのリンクが提供されている場合でも、運営者はリンク先のウェブサイトの内容について、一切の責任を負わないものとします。
  6.	本条は、消費者契約法その他の強行法規により免責または責任制限が認められない場合には適用しません。

第18条（個人情報の取扱い）
  1.	（事業者の名称）
  ANAあきんど株式会社
  2.	（個人情報保護管理者）
  ANAあきんど株式会社　総務人事部　部長
  3.	（個人情報の利用目的）
  お預かりした個人情報は、ANAの二地域居住　BLUE SKY LIFE（以後、本サイト）への利用登録、お試し二地域プランの手配（選べるe-GIFTの発行・送付やキャンセル料等の精算およびクレジットカード決済業務を含む）、二地域居住におすすめの地域や二地域居住に役立つ情報を記載したメールマガジンおよび運営者のサービス等のプロモーションの配信、本サービスに関するお問い合わせの受付と回答、キャンペーン等での抽選・景品発送対応、本サイト利用者の分析に基づく報告書の作成、それらに付帯、関連する全ての業務に関する対応に利用します。
  4.	（お預かりする個人情報の項目）
  ・氏名
  ・性別
  ・住所
  ・電話番号
  ・生年月日
  ・メールアドレス
  ・ANAマイレージクラブお客様番号
  ・病歴（アレルギー情報）
  ・身体、知的、精神障害に関する情報
  ・提携ポイント等の関連サービスとの連携に関する情報
  ・本サイト上におけるIT・システムデータ（行動履歴）
  　当社は、本サービスの提供に際し、以下のIT・システムデータを収集する場合があります。
  1　Cookie情報
  2　ログイン履歴
  3　本サービスのご利用情報（閲覧履歴を含む動態履歴等）
  4　端末ID
  5　関連サービスとのID連携に関する履歴
  ※一部アクセスログの収集・解析にはGoogle Analyticsを使用しております。
  Google Analyticsではクッキー（cookie）を使用し個人を特定する情報を含まずにログを収集します。
  なお、収集されるログはGoogle社のプライバシーポリシーに基づいて管理されます。
  Google Analyticsについて、およびGoogle社のプライバシーポリシーについては以下をご覧ください。
  Google Analytics 公式ウェブサイト
  https://www.google.com/intl/ja_jp/analytics/
  Google プライバシーポリシー
  https://www.google.com/intl/ja/policies/privacy/

  5.	（個人情報の第三者提供について）
  当社は、お試し二地域プランへの申込みのフォームにてご提示する「第三者提供先一覧」の宿泊事業者、地上手配先、地方自治体、関連省庁および提携ポイント等を利用するプランを申し込んだ場合における当該提携事業者等に対し、電子的方法等により第三者提供する場合がございます。
  (1)提供する個人情報の項目
  ・氏名
  ・性別
  ・住所
  ・電話番号
  ・生年月日
  ・メールアドレス
  ・病歴（アレルギー情報）
  ・身体、知的、精神障害に関する情報
  ・提携ポイント等の関連サービスとの連携に関する情報
  (2)個人情報の取扱いに関する契約
  あり
  また、下記の項目に該当する場合においてもお客さまの個人情報を第三者に提供する場合があります。
  ①法令に基づく場合
  ②人の生命、身体または財産の保護のために必要がある場合
  ③公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合
  ④国の機関若しくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合
  なお、共同利用または、業務委託により提供する場合は、第三者への開示または、提供に該当しません。
  6.	（共同利用について）
  当社は、次のとおりお客様の個人情報を共同利用します
  ＜共同して利用される個人情報の項目＞
  上記の（お預かりする個人情報の項目）記載のもの
  ＜共同して利用する者の範囲＞
  ANAグループ各社
  ＜利用する者の利用目的＞
  本業務の対応をするために、当社または共同して利用する会社が取扱う商品・サービスの提供を行うため。
  ＜個人情報の管理について責任を有する者の名称、住所および代表者名＞
  ANAホールディングス株式会社
  〒105-7140　東京都港区東新橋1丁目5番2号 汐留シティセンター
  代表取締役社長 芝田 浩二
  7.	（個人情報の委託について）
  個人情報の取扱いを外部に委託する場合は、当社が規定する個人情報管理基準を満たす企業を選定して委託を行い、適切な取扱いが行われるよう監督します。
  8.	（取得した個人情報の開示等およびお問合せ窓口）
  本人からの求めにより、当社が本件により取得した個人情報の利用目的の通知・開示・内容の訂正・追加または削除・利用の停止・消去または第三者への提供の停止および第三者提供記録の開示(「開示等」といいます。）に応じます。
  開示等に応じる窓口は、下記のとおりになります。
  〒 103-0027　東京都中央区日本橋二丁目14番1号 フロントプレイス日本橋
  ANAあきんど株式会社 総務人事部 個人情報取扱担当 行
  ANAあきんど個人情報取扱担当メールアドレス：privacy@ana-akindo.co.jp
  ※当社が提供するサービスに関する問い合わせ先ではございませんので、
  サービスに関してお問い合わせいただきましてもご回答いたしかねます。
  9.	（個人情報における任意性について）
  個人情報のご提供は、ご本人の任意です。ただし、ご提供いただけない場合は、本サービスをご利用いただけませんので、ご了承ください。

第19条（暴力団等反社会的勢力の排除）
  1.	利用者は、自らが暴力団、暴力団員、その他これらに準ずる者（総称して「反社会的勢力」）に該当しないこと、および将来にわたっても該当しないことを表明し、保証します。
  2.	利用者は、自らまたは第三者を利用して、暴力的な要求行為、法的な責任を超えた不当な要求行為、脅迫的な言動や暴力を用いる行為、業務を妨害する行為等を行わないことを確約します。
  3.	運営者は、利用者が前二項のいずれかに違反した場合、何らの催告を要することなく、直ちに当該利用者との契約を解除し、利用者登録を抹消できるものとします。

第20条（準拠法および管轄裁判所）
  1.	本規約の解釈にあたっては、日本法を準拠法とします。
  2.	本サイトの利用に関して紛争が生じた場合には、運営者の本店所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。

第21条（事務局からの連絡）
  1.	運営者は、ユーザーに対し、本サイトの運営に関する重要事項、メンテナンス情報、新機能のお知らせ、本サイトまたは関連サービスに関する案内、その他運営者が必要と判断する事項について、登録されたメールアドレスへの送信、本サイト内での通知、またはその他の方法により連絡を行うことができるものとします。
  2.	前項の連絡は、運営者が発信した時点、または本サイト上に表示された時点をもって、ユーザーに到達したものとみなします。
  3.	ユーザーは、運営者からの連絡を受信できるよう、登録情報のメールアドレスを常に最新かつ有効な状態に保つものとします。登録情報に誤りがある場合、または登録情報が最新でないことによりユーザーに生じた損害について、運営者は一切の責任を負いません。
  4.	運営者は、本サイトの利用上重要な連絡（例：規約変更、システム障害、緊急のお知らせ等）については、ユーザーの受信設定に関わらず送信する場合があります。
  5.	ユーザーは、本サイトまたは関連サービスのプロモーションやマーケティングを目的とした連絡について、運営者が別途定める方法により、受信の可否を設定できるものとします。

第22条（その他）
  1.	その他のサービスに関する情報は、以下ホームページをご参照ください。
  ○	お試し二地域プランURL
  ○	https://2chiiki.ana.co.jp/trial_plan/
`;

// JR西日本プラン利用特約（利用規約第2条第3項に定める個別規約）
export const jrWestTerms: string =
`二地域居住ポータルサイト（JR西日本プラン）利用特約

本利用特約は、「二地域居住ポータルサイト利用規約」に定めるANAの二地域居住 BLUE SKY LIFEで提供するサービス（以下、「本サービス」といいます。）のうち、同規約第2条第3項に定める個別規約であり、西日本旅客鉄道株式会社（以下、「JR西日本」といいます。）が営業する鉄道路線を利用するプラン（以下、「JR西日本プラン」といいます。）に参加する場合の利用条件等を定めるものです。JR西日本プランをご利用になる前に、「二地域居住ポータルサイト利用規約」及び本利用特約をよくお読みいただき、ご同意の上ご利用いただくようお願い申し上げます。万一ご同意いただけない場合には、大変申し訳ございませんがご利用をお控えください。ご利用いただいた場合、利用者は、下記の条件すべてにご同意いただいたものとして取り扱わせていただきます。

第1条（定義）
  ●	利用者：本サービスのうち、JR西日本プランを利用するすべての利用者
  ●	同行者：本サービスの申し込み時に同行者として登録され、当該申込者とともにJR西日本プランを利用する利用者
  ●	本サービスの運営者：ANAあきんど株式会社
  ●	JR西日本プランの運営者：ANAあきんど株式会社及びJR西日本
  ●	事務局：JR西日本プランの運営にあたり、ANAあきんど株式会社及びJR西日本が設置する窓口
  ●	WESTERポイント：JR西日本が策定する「WESTERポイント規約」に定めるサービスにおいて付与するポイント

第2条（適用）
  1.	JR西日本プランの内容及び利用条件等については、本利用特約の定めるところによります。
  2.	本利用特約に定めのない事項については、「二地域居住ポータルサイト利用規約」に定めるところによります。
  3.	「二地域居住ポータルサイト利用規約」第5条第2項、第7条及び第8条に定める事項については、JR西日本プランには適用しないこととします。また、本利用特約と「二地域居住ポータルサイト利用規約」に齟齬・矛盾が生じた場合は、本利用特約を優先して適用します。
  4.	JR西日本プラン利用者は、「二地域居住ポータルサイト利用規約」に同意し、同第4条に定める利用登録を行うこととします。

第3条（参加申し込み）
  1.	JR西日本プラン利用者は、「二地域居住ポータルサイト利用規約」、本利用特約及び「本事業における個人情報の取扱いに関する同意について」に同意のうえ、参加の申し込みをするものとします。

第4条（参加条件）
  1.	JR西日本プランの参加にあたっては、以下の条件を満たす必要があります。
  (1)対象期間中に、JR西日本の鉄道（各プラン指定の経路・きっぷに限る）を往復利用して対象地域を訪問すること。
  (2)滞在先地域が設定する地域体験メニューに参加すること。
  (3)二地域居住の課題解決に向けたアンケートへの回答をすること。
  (4)WESTER会員であること。ただし、13歳未満の同行者は除く。

第5条（JR西日本プランの内容及び制限）
  1.	JR西日本プランは、地域体験メニューと鉄道移動における負担軽減サポート（WESTERポイントの付与）から構成されています。なお、鉄道移動における負担軽減サポートの利用には、参加条件として定める地域体験メニューへの参加が必須となります。
  2.	地域体験メニューとは、対象地域の自治体がJR西日本プランへの参加条件として設定するメニューです。JR西日本プランの運営者はその故意または重大な過失による場合を除き、その内容、質、安全性、料金の支払い、債務、実施等に関する一切の責任を負いません。利用者が地域体験メニューの利用により損害を被った場合、または第三者に損害を与えた場合であっても、本サービス及びJR西日本プランの運営者は、その故意または重大な過失による場合を除き、その損害について一切の責任を負わないものとします。利用者は、自己の責任と費用において、地域体験メニュー提供事業者または第三者との間でこれを解決するものとします。
  3.	鉄道移動における負担軽減サポートは、対象期間において、JR西日本の鉄道を利用するための乗車券類（各プラン指定の経路・きっぷに限る）の購入に利用できるWESTERポイントを提供するものです。なお、プログラムへのお申込み確認後、概ね3週間程度でWESTERポイントを付与いたします（年末年始等は通常よりお時間を頂戴する場合がございます）。
  4.	鉄道移動における負担軽減サポートの実施にあたり、事務局で利用者のWESTERポイントの利用状況や購入したきっぷの利用状況を確認いたします。

第6条（JR西日本プランへの参加方法）
  1.	JR西日本プランへの参加及び鉄道利用サポート（WESTERポイントの受領）の利用方法は、以下のとおりです。
  (1)利用登録：ポータルサイト「ANAの二地域居住　BLUE SKY LIFE」に利用登録してください。
  (2)JR西日本プランへの申込み：利用条件や注意事項を確認のうえ、希望の地域のプランに申込みフォームよりお申込みください。
  ※対象地域の自治体にて申込み日程、申込者情報の確認（参加可否の審査）が行われます。
  (3)JR西日本プラン参加確定のご連絡：JR西日本プランの運営者及び対象地域の自治体による確認を行い、参加いただけることが確定した後、事務局より参加確定の連絡を行います。
  (4)WESTERポイントの受領：申込時に登録されたWESTER IDに対して、各プランで設定されたポイント数分のWESTERポイントを付与します。
  (5)乗車券類の購入：付与されたWESTERポイントは、JR西日本ネット予約「e5489」（以下、「e5489」といいます。）において、各プラン指定の駅間の「WESTERポイント特典きっぷ（普通車指定席用）」または「WESTERポイント特典チケットレス（普通車指定席用）」に交換して利用してください。
  ※WESTERポイントは、各プラン指定の駅間に必要な運賃・料金の一部に相当するポイント数を付与します。別途必要な乗車券類は、利用者負担で購入してください。
  (6)プラン参加：予約した列車で対象地域を訪問し、お申込みいただいたお試し二地域プランにご参加ください。
  (7)アンケート回答：プラン参加終了後、事務局よりアンケートを送付しますので、回答してください。また、事務局にてお客様のご利用実績を確認します。

第7条（キャンセル等の取扱い）
  1.	JR西日本プランの利用をキャンセルされる場合は、事務局へメールでご連絡ください。この場合、鉄道利用サポート（WESTERポイントの付与）の取扱いは次によります。
  (1)WESTERポイント付与前のキャンセル
  WESTERポイントの付与を中止します。
  (2)WESTERポイント付与後のキャンセル
  ○	乗車券類購入前（WESTERポイント使用前）のキャンセル
  JR西日本により、未使用WESTERポイントの取消し（付与したWESTERポイントの全部の減算）を行います。既に一部又は全部が使用されている場合、不足ポイント相当額（1ポイントは1円に換算）を請求させていただきます。
  ○	乗車券類購入後（WESTERポイント使用後）のキャンセル
  利用者ご自身で、きっぷの払いもどしの取扱いを行ってください（各きっぷで予め定められた払いもどし条件による取扱いとなります）。払いもどしにより利用者のWESTER IDにWESTERポイントが返却された場合は、JR西日本により、本件での付与ポイントの取消し（返却された本件での付与ポイント数の全部の減算）を行います。この場合、減算したWESTERポイント数が本件で付与したWESTERポイント数に満たない場合、不足ポイント相当額（1ポイントは1円に換算）を請求させていただきます。また、きっぷの払いもどし（WESTERポイントの返却）がない場合は、付与したWESTERポイント相当額を請求させていただきます。
  2.	JR西日本プランの利用日を変更される場合は、事務局へメールでご連絡ください。事務局にて、変更後の日程で受け入れが可能かを、対象地域の自治体に確認します。自治体による受け入れ可能であることを確認後、お客様ご自身で必要なきっぷの変更を行ってください（各きっぷで予め定められた乗車変更の条件により取扱いとなります）。

第8条（鉄道サポート利用時の注意事項）
  1.	JR西日本プランにて付与されるWESTERポイントの利用においては、以下の事項を遵守する必要があります。
  (1)付与されたWESTERポイントは、対象地域への移動に使用するきっぷに交換して利用いただきます。WESTERポイントは、利用者が各自で「e5489」を操作し、きっぷに交換いただく必要があります（乗車日の1か月前より予約が可能です）。
  (2)付与されたWESTERポイントは、必ず各JR西日本プランに定める指定の経路・きっぷ（「WESTERポイント特典きっぷ（普通車指定席用）」または「WESTERポイント特典チケットレス（普通車指定席用）」）に交換して利用する必要があります。JR西日本の鉄道を利用する場合であっても、指定のきっぷ以外への交換は不可とします。ただし、同きっぷの「グリーン車用」を利用する場合は、不足するWESTERポイントを利用者が負担することで交換可能とします。
  (3)付与されたWESTERポイントは、JR西日本プランへの参加以外の用途での利用はできません。
  (4)時期や利用列車によっては、追加でWESTERポイントが必要になる場合や、きっぷが購入できない場合があります。この場合は、交換可能な時期や利用列車に予定を変更して利用してください。
  (5)13歳未満の同行者に対しては、申込者のWESTER IDにWESTERポイントを付与します。申込者が「e5489」できっぷに交換してください。この場合、申込者と13歳未満の同行者は同一行程で利用する必要があります。
  (6)小学生の同行者への付与ポイント数は、別途ポータルサイト等に定めます。幼児、乳児の利用者においては、JR西日本プランにおけるWESTERポイント付与の対象外です。

第9条（利用制限及び参加取消し）
  1.	JR西日本プランの運営者は、利用者が以下のいずれかに該当する場合には、利用者に事前に通告することなく、利用の制限または利用者の参加取消しをできるものとします。この場合、未使用WESTERポイントは取消し（付与したWESTERポイントの全部または一部を減算）します。また、既に使用済みのWESTERポイントについて不正利用が確認された場合には、当該不正利用によりJR西日本プランの運営者が実際に被った合理的な損害の範囲内で賠償を請求できるものとします。
  (1)「二地域居住ポータルサイト利用規約」または本利用特約のいずれかの条項に違反した場合
  (2)付与したWESTERポイントについて、JR西日本プラン以外の用途に使用する等の不適切な使用が確認された場合
  (3)利用者が申告した事項に虚偽の事実があることが判明した場合
  (4)JR西日本プランの運営者又は事務局からの連絡に対し、一定期間返答がない場合
  (5)その他、JR西日本プランの運営者がJR西日本プランの利用が適当でないと判断した場合
  2.	JR西日本プランの運営者は、前項に基づく行為により利用者に生じた損害について、一切の責任を負いません。

第10条（本利用特約及びJR西日本プラン内容の変更）
  1.	JR西日本プランの運営者は、以下のいずれかに該当する場合には、本利用特約及びJR西日本プランの内容を変更することができるものとします。
  (1)当該変更が、利用者の一般の利益に適合するとき。
  (2)当該変更が、JR西日本プランの利用目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき。
  2.	JR西日本プランの運営者は、前項による本利用特約等の変更を行う場合、変更後の本利用特約等の内容及びその効力発生日を、当該効力発生日の少なくとも14日前までに、「二地域居住ポータルサイト」への掲載または利用者への電子メールによる通知その他適切な方法により周知するものとします。

第11条（個人情報の取扱い）
  お預かりした個人情報は、「二地域居住ポータルサイト利用規約」第18条によるほか、以下により取り扱います。
  1.	（事業者の名称）
  西日本旅客鉄道株式会社
  2.	（個人情報保護管理者）
  西日本旅客鉄道株式会社 共創ソリューション本部　マーケティング本部 課長
  3.	（個人情報の利用目的）
  お預かりした個人情報は、本サービスに関するお問い合わせの受付と回答、ご利用実績の確認、それらに付帯、関連する全ての業務に関する対応に利用します。
  4.	（個人情報の第三者提供について）
  JR西日本は、前号に記載の利用目的の達成に必要な範囲で、お試し二地域プランへの申込みのフォームにてご提示する「第三者提供先一覧」の宿泊事業者、地上手配先、地方自治体および関連省庁等ならびにANAあきんど株式会社および株式会社スカイツアーズに対し、電子的方法等により第三者提供する場合がございます。
  (1)提供する個人情報の項目
  ・氏名
  ・性別
  ・住所
  ・電話番号
  ・生年月日
  ・メールアドレス
  ・WESTER ID
  ・ご利用、ご予約実績情報
  また、下記の項目に該当する場合においてもお客さまの個人情報を第三者に提供する場合があります。
  ①法令に基づく場合
  ②人の生命、身体または財産の保護のために必要がある場合
  ③公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合
  ④国の機関若しくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合
  なお、共同利用または、業務委託により提供する場合は、第三者への開示または、提供に該当しません。
  5.	（個人情報の委託について）
  個人情報の取扱いを外部に委託する場合は、JR西日本が規定する個人情報管理基準を満たす企業を選定して委託を行い、適切な取扱いが行われるよう監督します。
  6.	（取得した個人情報の開示等およびお問合せ窓口）
  本人からの求めにより、JR西日本が本件により取得した個人情報の利用目的の通知・開示・内容の訂正・追加または削除・利用の停止・消去または第三者への提供の停止および第三者提供記録の開示(「開示等」といいます。）に応じます。
  開示等に応じる窓口は、下記のとおりになります。
  〒530-8341　大阪市北区芝田二丁目4番24号
  西日本旅客鉄道株式会社 共創ソリューション本部 マーケティング本部　二地域居住プラン個人情報取扱担当 行
  個人情報取扱担当メールアドレス：2chiiki-kyoju-desk-jrw	westjr.co.jp
  ※JR西日本が提供するサービスに関する問い合わせ先ではございませんので、
  サービスに関してお問い合わせいただきましてもご回答いたしかねます。
  7.	（個人情報における任意性について）
  個人情報のご提供は、ご本人の任意です。ただし、ご提供いただけない場合は、本サービスをご利用いただけませんので、ご了承ください。
`;

export const privacyPolicy: string = 
`（事業者の名称）  
ANAあきんど株式会社  	

（個人情報保護管理者）
ANAあきんど株式会社　総務人事部　部長 

（個人情報の利用目的）   
お預かりした個人情報は「ANAの二地域居住　BLUE SKY LIFE」のサービスや利用・層さ等に関するお問い合わせへの対応・それに付帯、関連する全ての業務に関する対応に利用します。

（お預かりする個人情報の項目）                                                                   	
・氏名
・メールアドレス
・本サイト上におけるIT・システムデータ（行動履歴）
　当社は、本サービスの提供に際し、以下のIT・システムデータを収集する場合があります。
　①Cookie情報
　②本サービスのご利用情報（閲覧履歴を含む動態履歴など）端末ID
　※一部アクセスログの収集・解析にはGoogle Analyticsを使用しております。
　　Google Analyticsではクッキー（cookie）を使用し個人を特定する情報を含まずに
　　ログを収集します。なお、収集されるログはGoogle社のプライバシーポリシーに
　　基づいて管理されます。Google Analyticsについて、およびGoogle社のプライバシー
　　ポリシーについては以下をご覧ください。
Google Analytics 公式ウェブサイト
https://www.google.com/intl/ja_jp/analytics/
Google プライバシーポリシー
https://www.google.com/intl/ja/policies/privacy/

（個人情報の第三者提供について）
ご本人の同意がある場合を除き、今回ご入力いただく個人情報は第三者に提供しません。
ただし、下記のいずれかに該当する場合は、事前にご本人の同意を得ることなく当該個人情報を第三者に提供する場合があります。
(1)法令に基づく場合
(2)人の生命、身体又は財産の保護のために必要がある場合であって、
本人の同意を得ることが困難であるとき
(3)公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、
本人の同意を得ることが困難であるとき
(4)国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがあるとき
なお、共同利用または、業務委託により提供する場合は、第三者への開示または、提供に該当しません。									

（共同利用について）								
当社は、次のとおりお客様の個人情報を共同利用します				
＜共同して利用される個人情報の項目＞
上記の（お預かりする個人情報の項目）記載のもの
＜共同して利用する者の範囲＞
ANAグループ各社					
＜利用する者の利用目的＞
本業務の対応するために、当社または共同して利用する会社が取扱う商品・サービスの提供を行うため。									
＜個人情報の管理について責任を有する者の名称、住所及び代表者名＞		
ANAホールディングス株式会社							
〒105-7140　東京都港区東新橋1丁目5番2号 汐留シティセンター			
代表取締役社長 芝田 浩二					
＜取得方法＞
本フォームにて取得いたします。				

（個人情報の委託について）							
個人情報の取扱いを外部に委託する場合は、当社が規定する個人情報管理基準を満たす企業を選定して委託を行い、適切な取扱いが行われるよう監督します。			

（取得した個人情報の開示等及びお問合せ窓口）					
本人からの求めにより、当社が本件により取得した個人情報の利用目的の通知・開示・内容の訂正・追加または削除・利用の停止・消去又は第三者への提供の停止及び第三者提供記録の開示（「開示等」といいます。）に応じます。
開示等に応じる窓口は、下記のとおりになります。				
〒 103-0027	東京都中央区日本橋二丁目14番1号 フロントプレイス日本橋	
ANAあきんど株式会社 総務人事部 個人情報取扱担当 行				
ANAあきんど個人情報取扱担当メールアドレス：privacy@ana-akindo.co.jp	
※当社が提供するサービスに関する問い合わせ先ではございませんので、
　サービスに関してお問い合わせいただきましてもご回答いたしかねます。

（個人情報における任意性について） 
個人情報のご提供は、ご本人の任意です。ただし、ご提供いただけない場合は、本サービスをご利用いただけませんので、ご了承ください。
`;